import { Button } from "@/components/button";

type ReviewFooterProps = {
  /** False while the brief is missing a required criterion. */
  canSubmit?: boolean;
  isSavingDraft?: boolean;
  isSubmitting?: boolean;
  onBackToChat?: () => void;
  onSaveToDrafts?: () => void;
  onSubmit?: () => void;
};

export function ReviewFooter({
  canSubmit = false,
  isSavingDraft = false,
  isSubmitting = false,
  onBackToChat,
  onSaveToDrafts,
  onSubmit,
}: ReviewFooterProps) {
  return (
    <footer className="sticky bottom-0 z-10 flex items-center justify-end border-t border-border-primary bg-bg-primary px-3xl py-4">
      <div className="flex items-center gap-3">
        {onBackToChat ? (
          <button
            className="cursor-pointer text-sm font-semibold text-text-secondary hover:text-text-primary"
            onClick={onBackToChat}
            type="button"
          >
            Back to chat
          </button>
        ) : null}
        {onSaveToDrafts ? (
          <Button
            color="gray"
            isDisabled={isSavingDraft}
            onPress={onSaveToDrafts}
            variant="secondary"
          >
            {isSavingDraft ? "Saving..." : "Save to drafts"}
          </Button>
        ) : null}
        <Button
          isDisabled={!canSubmit || isSubmitting}
          onPress={onSubmit}
          variant="primary"
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </footer>
  );
}
